<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector
								[ShowAll]="true"
								[ShowAllID]="SchoolSelectShowAllID"
								[ShowAllText]="SchoolSelectShowAllText"
								[IsReport]="true"
								[ReportID]="436"
							>
							</caass-schoolselector>
						</div>
					</div>

					<!--StudentActive-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Student Active</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="StudentActiveID" [(ngModel)]="report.StudentActiveID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstActive" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--BookSubjectID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Subject</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="BookSubjectID" [(ngModel)]="report.BookSubjectID" (ngModelChange)="onBookSubjectChange($event)">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstBookSubject" [ngValue]="o.BookSubjectID">
									{{ o.BookSubjectName }}
								</option>
							</select>
						</div>
					</div>

					<!--BookTitleID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Title</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="BookTitleID" [(ngModel)]="report.BookTitleID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstBookTitle" [ngValue]="o.BookTitleID">
									{{ o.BookTitle }}
								</option>
							</select>
						</div>
					</div>

					<!--BookStatusID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Status</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="BookStatusID" [(ngModel)]="report.BookStatusID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstBookStatus" [ngValue]="o.BookStatusID">
									{{ o.StatusName }}
								</option>
							</select>
						</div>
					</div>

					<!--OrderBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Order By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OrderByID" [(ngModel)]="report.OrderByID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstOrderBy" [ngValue]="o.OrderByID">
									{{ o.OrderByDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--OrderBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort Order</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortOrderID" [(ngModel)]="report.SortOrderID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of lstSortOrder" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
